export default __webpack_public_path__ + "static/media/loading-placeholder.722128cd.svg";